import { createReducer, on } from '@ngrx/store';

import { setCalculatedBatteryCapacity } from './homebattery-capacity.actions';

export const homebatteryCapacitySelectorKey = 'homebattery-capacity';

export interface HomeBatteryCapacityState {
  calculatedBatteryCapacity: number | null;
}

export const initialHomebatteryCapacityState: HomeBatteryCapacityState = {
  calculatedBatteryCapacity: null,
};

export const homebatteryCapacityReducer = createReducer(
  initialHomebatteryCapacityState,
  on(setCalculatedBatteryCapacity, (_, { calculatedBatteryCapacity }) => {
    return {
      calculatedBatteryCapacity,
    };
  })
);
